var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79027 19C9.91827 19 10.0463 18.951 10.1443 18.854C10.3393 18.659 10.3393 18.342 10.1443 18.147L1.49827 9.50099L10.1443 0.85499C10.3393 0.65999 10.3393 0.34299 10.1443 0.147989C9.94927 -0.0470105 9.63227 -0.0470105 9.43727 0.147989L0.437266 9.14799C0.242266 9.34299 0.242266 9.65999 0.437266 9.85499L9.43727 18.855C9.53527 18.953 9.66327 19.001 9.79127 19.001L9.79027 19Z",
    fill: "#1BA2CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.af30cd7cf4934cdadf88b2583709ba95.svg";
export { ForwardRef as ReactComponent };